import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// Target routes require a valid target (category) session, stored under its own
// credential (target-wiki-token).
export default function RequireAuth() {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
